// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cc8b8a42","693":"3d51822a","845":"a66d9687"}[chunkId] + ".chunk.js";
};